import React, {Component} from "react";
import {bindActionCreators} from "redux";
import * as actions from "../../actions";
import {connect} from "react-redux";
import _ from 'lodash';
import {Container, Divider, Label, Segment, Table} from "semantic-ui-react";
import history from "../../history";
import Statuses from "./statuses";
import {Pagination} from "../utils/pagination";
import LabelStatuses from "./lables";
import {l, t} from "../../i18n";

function mapStateToProps(state) {
  return {
    getSplitOrderByCode: state.getSplitOrderByCode,
    getSplitOrderItems: state.getSplitOrderItems
  };
}

class SplitDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: null,
      invoice: null,
      loading: true,
      data: [],
      meta: {
        count: '',
        current_page: '',
        per_page: '',
        last_page: '',
        to: null,
      },
      page: 1,
      nextPage: '',
      prevPage: '',
      pages: [],
    }
  }

  getDirectDetails(code) {
    history.push(l + `/panel/orders/split/item/${code}`);
  }

  componentDidMount() {
    this.props.actions.getSplitOrderByCode(this.props.match.params.code)
    this.props.actions.getSplitOrderItems(this.props.match.params.code)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.getSplitOrderByCode !== this.props.getSplitOrderByCode) {
      let order = this.props.getSplitOrderByCode;
      if (order) {
        this.setState({order: order.data, invoice: order.invoice, loading: false})
      }
    }

    if (prevProps.getSplitOrderItems !== this.props.getSplitOrderItems) {
      let item = this.props.getSplitOrderItems;
      if (item) {
        this.setState({data: item.data, meta: item.meta})
      }
    }
  }

  callPagination(options) {
    this.setState({
      current_page: options.pageNo,
      page: options.name,
      pages: options.pages,
      last_page: options.pagesCount,
      offset: options.offset,
      per_page: options.limit,
      showErrors: false,
      value: ''
    });
    let params = options.params;
    if (this.state.status)
      params.status = this.state.status;

    let data = {
      page: options.pageNo,
    }

    this.props.actions.getSplitOrderItems(this.props.match.params.code, data);
  }

  render() {
    let {order, data, invoice, meta} = this.state;
    if (order) {
      let status = order.status;
      return (
        <Segment basic>
          <Container>
            <Segment basic>
              <Divider horizontal>{t("orders.splitDetails")}</Divider>
              <Segment>
                <Label attached='top'>{t("orders.split")}</Label>
                <Table compact celled basic='very' columns={2}>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.status")}</Table.Cell>
                      <Table.Cell>
                        <LabelStatuses status={status}/>
                        &nbsp;
                        <Statuses status={status}/>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.code")}</Table.Cell>
                      <Table.Cell>{order.code}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.currency")}</Table.Cell>
                      <Table.Cell>{order.currency}</Table.Cell>
                    </Table.Row>
                    {order.metadata && <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.metadata")}</Table.Cell>
                      <Table.Cell>{order.metadata}</Table.Cell>
                    </Table.Row>}
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.created")}</Table.Cell>
                      <Table.Cell>{order.createdAt}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.updated")}</Table.Cell>
                      <Table.Cell>{order.updatedAt}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Segment>
              {!!invoice?.length &&
              <Segment>
                <Label attached={"top"}>{t("orders.invoice")}</Label>
                <Table compact celled basic='very' columns={2}>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.amount")}</Table.Cell>
                      <Table.Cell>{parseFloat(invoice.amount).toFixed(2)} {invoice.currency}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.description")}</Table.Cell>
                      <Table.Cell>{invoice.description}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell className='boldCell'>{t("orders.iban")}</Table.Cell>
                      <Table.Cell>{invoice.iban}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Segment>}
              {data &&
              <>
                <Divider horizontal>{t("orders.splitItemsList")}</Divider>
                <Table selectable stackable compact columns={3}>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell textAlign={"center"}>{t("orders.code")}</Table.HeaderCell>
                      <Table.HeaderCell textAlign={"center"}>{t("orders.updated")}</Table.HeaderCell>
                      <Table.HeaderCell textAlign={"center"}>{t("orders.status")}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {_.map(data, ({data}) => (
                      <Table.Row key={data.code} onClick={this.getDirectDetails.bind(this, data.code)}>
                        <Table.Cell textAlign={"center"}>{data.code}</Table.Cell>
                        <Table.Cell textAlign={"center"}>{data.updatedAt}</Table.Cell>
                        <Table.Cell textAlign={"center"}><LabelStatuses status={data.status}/></Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                  <Table.Footer>
                    <Pagination
                      columnNumber={5} showFunction={this.callPagination.bind(this)}
                      pageNo={meta.current_page} pages={this.state.pages}
                      pagesCount={meta.last_page} limit={meta.per_page}/>
                  </Table.Footer>
                </Table>
              </>}
            </Segment>
          </Container>
        </Segment>
      )
    } else {
      return <Segment basic loading={this.state.loading}/>
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {actions: bindActionCreators(actions, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(SplitDetails)
